import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';

import { OrderTrackingService } from './order-tracking.service';
import type { Order, TrackingRequest } from './order.interface';

declare let grecaptcha: any;

type OrderState = {
  error: string | null;
  order: Order | null;
};

const initialState: OrderState = {
  error: null,
  order: null
};

export const OrderStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, orderTrackingService = inject(OrderTrackingService)) => ({
    _getOrderWithToken: rxMethod<TrackingRequest>(
      pipe(
        switchMap((request) =>
          orderTrackingService.getOrderTrackingInfo(request).pipe(
            tapResponse({
              next: (order) => patchState(store, { order }),
              error: (error) => {
                if (error instanceof HttpErrorResponse && (error.status === 429 || error.status === 401)) {
                  patchState(store, { error: TOO_MANY_REQUESTS });
                } else {
                  patchState(store, { error: NOT_FOUND });
                }
              }
            })
          )
        )
      )
    )
  })),
  withMethods((store) => ({
    requestOrder: (orderId: string, legStopId?: string) => {
      patchState(store, { error: null, order: null });

      grecaptcha.ready(() => {
        grecaptcha
          .execute('6Lcj5n4eAAAAAN3LiCZ9KBSoRQKuxs_E-dpCh49m', { action: 'requestOrder' })
          .then((token: string) => {
            store._getOrderWithToken({ orderId, legStopId, token });
          });
      });
    }
  }))
);

const TOO_MANY_REQUESTS = "You've exceeded the maximum number of requests, please wait one hour and try again.";
const NOT_FOUND = "Sorry, we can't find the order you're looking for.";
